import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e269f7c6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "left"
};
const _hoisted_2 = {
  class: "right"
};
export default /*#__PURE__*/_defineComponent({
  props: {
    isWhiteTheme: {
      type: Boolean,
      default: false
    },
    title: String
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["section-header", __props.isWhiteTheme ? 'is-white-theme' : ''])
      }, [_createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default")])], 2);
    };
  }

});